<template>
    <div id="spinner">
      <div class="spinner-obj">
        <div class="spinner-circle"></div>
      </div>
    </div>
  </template>

<style lang="stylus">
#spinner {
  display: inline-flex;
}

.spinner-obj-mobile {
  margin-top: 77%;
  margin-bottom: 50%;
}

$duration = 1.4s

.spinner-circle {
  width: 40px;
  height: 40px;
  border: 6px solid rgba(36, 165, 211, 0.2);
  border-top: 6px solid #24a5d3;
  border-radius: 50%;
  animation: spin $duration linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
